import * as React from 'react'
import { JobMode } from '../Job'
import { copyObject } from '../../../../utils'
import { ClientObj, ClientT } from '../../../../types/Users'
import { useImmer } from 'use-immer'
import FormEditClient from './FormEditClient'
import { JobT } from '../../../../types/Job'




interface ClientTabProps {
    client: ClientT
    job: JobT
    updateJob(key: string, value: any): void
    jobMode: JobMode
    customSaveJob?(args: JobT): Promise<JobT>
    tabIsActive: boolean
}

const ClientTab: React.FunctionComponent<ClientTabProps> = (props): JSX.Element => {
    const [isReady, setIsReady] = React.useState(false)
    const [disabled, setDisabled] = React.useState(true);
    const [modeEdit, setModeEdit] = React.useState(false);

    const [fieldsClient, setFieldsClient] = useImmer(ClientObj);

    React.useEffect(() => {
        setIsReady(true)
    }, [])


    if (!isReady) {
        return null;
    }

    if (!props.tabIsActive) {
        return null
    }

    return (
        <div className="d-flex flex-column">
            <FormEditClient
                client={props.job.client}
                typeClient="primary"
                keyInJob={"client"}
                isBillingContact={props.job.isBillingContact}
                updateJob={props.updateJob}
                customSaveJob={props.customSaveJob}
                jobMode={props.jobMode} />

            {props.job.isBillingContact == false && <FormEditClient
                client={props.job.billingContact}
                typeClient="billing"
                keyInJob={"billingContact"}
                updateJob={props.updateJob}
                customSaveJob={props.customSaveJob}
                jobMode={props.jobMode} />}

        </div>
    )
}

export default ClientTab